<template>
  <ApexCharts
    ref="chart"
    height="400px"
    :class="`${name}-chart`"
    :options="chartOptions"
    :series="currentSeries"
  />
</template>

<script>

import VueApexCharts from "vue3-apexcharts";

export default {
  name: 'ValidatorChartSingle',
  components: {
    ApexCharts: VueApexCharts,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isZoomed: false,
      chartOptions: {},
      currentSeries: [],
    };
  },
  watch: {
    data: {
      handler(newData) {
        if (this.$refs.chart?.updateOptions) {
          const series = newData.series;
          if (series.length !== this.currentSeries.length) {
            this.currentSeries = series;
            const options = newData;
            options.chart.width = '100%';
            options.stroke = {
              width: 2,
            };
            options.title.align = 'center';
            this.chartOptions = options;
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.$refs.chart?.updateOptions) {
        const options = this.data;
        options.chart.width = '100%';
        options.stroke = {
          width: 2,
        };
        options.title.align = 'center';
        this.chartOptions = options;
      }
      window.dispatchEvent(new Event('resize'));
    }, 500);
  },
};
</script>

<style lang="scss" scoped>
.chart-area {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
